import { Component, Vue, Watch } from 'vue-property-decorator';

import Pagination from '@/components/pagination/pagination.vue';
import Single from '@/components/single/single.vue';

import { format } from 'date-fns';

@Component({
    components: {
        Pagination,
        Single,
    },
    metaInfo() {
        return {
            title: this.$route.meta.title,
        };
    },
})
export default class Blog extends Vue {
    document: any = false;

    pageSize = 3;

    loading = false;

    @Watch('$store.state.filters')
    onFiltersChange() {
        this.getData();
    }

    @Watch('$store.state.deldup.del')
    onDelChange() {
        this.getData();
    }

    @Watch('$store.state.deldup.dup')
    onDupChange() {
        this.getData();
    }

    @Watch('$route.meta.child')
    onRouteChanged() {
        if (this.$route.meta.child) {
            this.getData();
        }
    }

    mounted() {
        this.getData();
    }

    formatDate(date: string) {
        return format(date, 'D MMMM YYYY');
    }

    async getData() {
        this.loading = true;

        const query: any[] = [
            this.$prismic.Predicates.at('document.type', this.$route.meta.child),
        ];

        if (this.$route.meta.filter) {
            if (this.$store.getters.filter) {
                query.push(
                    this.$prismic.Predicates.any('document.tags', this.$store.getters.blogfilter),
                );
            }

            if (!this.$store.state.deldup.del) {
                query.push(
                    this.$prismic.Predicates.any('document.tags', ['duplication']),
                );
            }

            if (!this.$store.state.deldup.dup) {
                query.push(
                    this.$prismic.Predicates.any('document.tags', ['deletion']),
                );
            }
        }

        this.document = await this.$prismic.client.query(
            query,
            {
                page: this.page,
                pageSize: this.pageSize,
                orderings: `[my.${this.$route.meta.child}.date desc]`,
            },
        );

        if (this.page > this.document.total_pages) {
            this.$router.push({
                name: this.$route.name,
                params: {
                    page: this.document.total_pages,
                },
            });
        }

        this.loading = false;
    }

    get page() {
        if (this.$route.params.page) {
            return this.$route.params.page;
        } else {
            return 1;
        }
    }

    @Watch('page')
    onPageChanged() {
        this.getData();
    }
}
